export const appInfo = {
    title: 'Hyper-Timesheet'
};